module.exports = new Promise(resolve => {
    const timestamp = Math.floor(Date.now() / 60 / 1000);
    const script = document.createElement('script');
    const first = window.location.host.split('.')[0];
      if (['local', '-test', '-stable', '-pre'].some(keyword => first.includes(keyword))) {
        script.src = '//hy-static-pre.intra.xiaojukeji.com/hy-compo/remoteEntry.js?timestamp=' + timestamp;
      } else {
        script.src = '//hy-static.xiaojukeji.com/hy-compo/remoteEntry.js?timestamp=' + timestamp;
      }
  
    script.onload = () => {
      const proxy = {
        get: (request) => window['hy_mf_pc'].get(request),
        init: (arg) => {
          try {
            return window['hy_mf_pc'].init(arg)
          } catch(e) {
            console.log('remote container already initialized')
          }
        }
      };
      resolve(proxy);
    }
    document.head.appendChild(script);
  });